import Button from '../../../../Button/Button';
import React from 'react'
import './index.scss'

interface ActionButtonsProps {
  closeDropdown: () => void;
  clearAll: () => void;
  applyFilter: () => void;
  disabled?: boolean;
  
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ closeDropdown, clearAll, applyFilter, disabled }) => {
  return (
    <div className="ActionButtons">
      <div className="ActionButtons__left">
        <Button buttonType="tertiary" onClick={closeDropdown}>{'Cancel'}</Button>
      </div>
      <div className="ActionButtons__right">
        <Button buttonType="secondary" onClick={clearAll} disabled={disabled}>{'Clear All'}</Button>
        <Button buttonType="primary" onClick={applyFilter} disabled={disabled}>{'Apply'}</Button>
      </div>
    </div>
  )
}

export default ActionButtons